// import TweenMax from "gsap/TweenMax";

import "./alert.js";
import "./bg.js";
import "./collapse.js";
import "./galerie.js";
import "./lang.js";
import "./service_produit.js";
import "./realisations.js";
import "./accordion.js";
import "./modal.js";
import "./swiper-leaderboard.js";
import "./dropdown.js";
import "./leaflet.js";
import "./leaflet-seniors.js";
import "./leaflet-enfance.js";
import "./leaflet-assuetude.js";
import "./form.js";
import "./page-sous-menu.js";
import "./swiper-site-externe.js";
import "./lieux-tabs.js";
import "./responsive-modifications.js";
import "./cta-rdv.js";
import "./service-tabs.js";
import "./service-lieux-tabs.js";
import "./medecin.js";
import "./service-soins.js";
import "./selectSearch.Js";
import "./header.js";
import "./message-cookie.js";
import "./estimation.js";
// import './splittext.js'
// import './transition.js'
import "./leaflet-fiche-centre";
